export default "__VITE_ASSET__BuLM8hnF__"